module.exports = __webpack_public_path__ + "img/Dog.97a2a89c.jpg";